/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Readiness_OverloadInputs */

const en_ui_readiness_overload = /** @type {(inputs: Ui_Readiness_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No-Go`)
};

const de_ui_readiness_overload = /** @type {(inputs: Ui_Readiness_OverloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stopp`)
};

/**
* | output |
* | --- |
* | "No-Go" |
*
* @param {Ui_Readiness_OverloadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_readiness_overload = /** @type {((inputs?: Ui_Readiness_OverloadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Readiness_OverloadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_readiness_overload(inputs)
	return de_ui_readiness_overload(inputs)
});